import Select from "react-select";
import {newSelectStyles} from "../../common/shared/select.styled";
import fileIcon from "../../images/newDesign/file.svg";
import deleteIcon from "../../images/newDesign/deleteRed.svg";
import {useSelector} from "react-redux";
import {useEffect, useMemo, useState} from "react";
import {UploadListItemStyled} from "./UploadListItem.styled";
import {useTranslation} from "react-i18next";
import classNames from "classnames";
import {ArchiveFileType} from "./UploadItem";
import {FileSize} from "../../ui/FileSize";


export function UploadListItem({ item, onDelete = (item) => void null }) {
    const { t } = useTranslation();
    const ltr = useSelector(state => state.common.ltrEnabled);
    const [lastUpdate, setLastUpdate] = useState(Date.now());

    const typeOptions = useMemo(() => Object.values(ArchiveFileType).map(type => ({ value: type, label: t(`archive.file_type.${type}`) })), [t]);

    useEffect(() => {
        item.addEventListener('change', handleItemChange);
        return () => item.removeEventListener('change', handleItemChange);
    }, [item]);

    const loading = item.loaded != null;

    function handleItemChange(e) {
        // NOTE: this state change is only for component rerender
        setLastUpdate(Date.now());
    }

    return (
        <UploadListItemStyled>
            <img src={fileIcon} />
            <div className='progress-line bllink-text-tiny'>
                <div className='progress-head'>
                    <div className='file-name bllink-text-tiny-bold'>{item.name}</div>
                    <div><FileSize>{item.size}</FileSize></div>
                </div>
                <progress max={item.size} value={item.loaded}></progress>
                <div className={classNames({ 'no-progress': !loading })}>
                    <span>{Math.round( 100 * item.loaded / item.size)}%</span> <span>{t('archive.upload_per_cent_done')}</span>
                </div>
            </div>
            <Select
                isDisabled={loading}
                className="select"
                placeholder={t('archive.select_file_type')}
                styles={newSelectStyles}
                options={typeOptions}
                value={typeOptions.find(option => option.value === item.metadata.type) }
                onChange={option => item.setType(option.value)}
                isRtl={!ltr}
            />
            <button type="button" className="delete" onClick={() => onDelete(item)} disabled={loading}>
                <img src={deleteIcon} />
            </button>
        </UploadListItemStyled>
    )
}
